export default __webpack_public_path__ + "static/media/f.d8c815d0.mp4";